<template>
  <div class="tab-content">
    <div class="main-filters">
      <div class="filter-list">
        <div class="filter-item">
          <span class="title">Name:</span>
          <el-input v-model="filters.name" placeholder="Search" clearable @change="handleFiltersChange" />
        </div>
        <div class="filter-item">
          <span class="title">Active:</span>
          <el-select
            v-model="filters.is_active" placeholder=" "
            @change="handleFiltersChange"
          >
            <el-option :key="0" label="All" value=""></el-option>
            <el-option :key="1" label="True" :value="1"></el-option>
            <el-option :key="2" label="False" :value="2"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="title">Featured:</span>
          <el-select
            v-model="filters.is_featured" placeholder=" "
            @change="handleFiltersChange"
          >
            <el-option :key="0" label="All" value=""></el-option>
            <el-option :key="1" label="True" :value="1"></el-option>
            <el-option :key="2" label="False" :value="2"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="title">Sort:</span>
          <el-select
            v-model="filters.sort" placeholder=" "
            @change="handleFiltersChange"
          >
            <el-option :key="0" label="Name" :value="0"></el-option>
            <el-option :key="1" label="Featured Order" :value="1"></el-option>
            <el-option :key="2" label="Player Position" :value="2"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="">
      <el-table :data="productsPage" v-loading="flagLoading.getProductsAll" border>
        <el-table-column type="index" label="#" :index="generateIndex" />
        <el-table-column prop="brand" label="Brand" />
        <el-table-column prop="model" label="Model" />
        <el-table-column label="Price">
          <template #default="scope">
            <span>{{ `$${scope.row.price.default.price}` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Active">
          <template #default="scope">
            <div class="td-checkbox">
              <div
                :class="['ca-checkbox', scope.row.is_active ? 'active': 'inactive']"
                @click="toggleProductActive(scope.$index)"
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Featured">
          <template #default="scope">
            <div class="td-checkbox">
              <div
                :class="['ca-checkbox', scope.row.is_featured ? 'active': 'inactive']"
                @click="toggleProductFeatured(scope.$index)"
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Featured Order">
          <template #default="scope">
            <el-input
              v-model="scope.row.featured_order" :placeholder="`1-${productsAll.length}`" size="small"
              @change="(val) => { changeProductFeaturedOrder(scope.$index, val) }" :style="{ width: '100px' }"
            />
          </template>
        </el-table-column>
        <el-table-column label="Player Position">
          <template #default="scope">
            <el-select
              v-model="scope.row.player_position" style="width: 60px;" placeholder=" " size="mini"
              @change="(val) => { changeProductPlayerPosition(scope.$index, val) }"
            >
              <el-option :key="0" label="" value=""></el-option>
              <el-option v-for="num in 3" :key="num" :label="num" :value="num"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Placement Priority">
          <template #default="scope">
            <el-select
              v-model="scope.row.placement_priority" style="width: 60px;" placeholder=" " size="mini"
              @change="(val) => { changeProductPlacementPriority(scope.$index, val) }"
            >
              <el-option :key="0" label="" value=""></el-option>
              <el-option v-for="num in 3" :key="num" :label="num" :value="num"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px; display: flex; flex-direction: row-reverse;">
      <el-pagination
        v-model:currentPage="pageNum"
        v-model:page-size="pageSize"
        :page-sizes="[20, 50, 100]"
        background
        layout="sizes, prev, pager, next"
        :total="totalNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-row style="margin-top: 30px;">
      <el-button class="el-btn-blue" @click="updateInstance" :loading="flagLoading.save">SAVE CHANGES</el-button>
      <el-button @click="returnBack">CANCEL</el-button>
    </el-row>
  </div>
</template>

<script>
import { reactive } from 'vue'
import _ from 'lodash'
export default {
  name: 'TabImages',
  props: {
    role: String,
    actionItem: Object
  },
  emits: [],
  components: {
  },
  data () {
    const flagLoading = reactive({
      getProductsAll: false,
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    const filters = reactive({
      name: '',
      is_featured: '',
      is_active: '',
      sort: 0
    })
    return {
      instance: {},
      productsAll: [],
      productsFilter: [],
      productsPage: [],
      products: [],
      productsData: {},
      pageNum: 1,
      pageSize: 20,
      totalNum: 0,
      featuredOrderOptions: [],
      flagLoading,
      flagVisible,
      actionItems,
      filters
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.instance = { ...val }
          if (val && val.products) {
            this.products = [...val.products]
            const productsData = {}
            val.products.map(product => {
              productsData[product.product_id] = product
            })
            this.productsData = productsData
            this.getProductsAll()
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getProductsAll: function () {
      this.flagLoading.getProductsAll = true
      const url = '/api/v1/admin/mobile_instances/products'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          const productsAll = []
          res.data.products.map(product => {
            const productData = that.productsData[product.product_id]
            if (productData) {
              product.is_active = productData.is_active
              product.is_featured = productData.is_featured
              product.featured_order = productData.featured_order
              product.player_position = productData.player_position
              product.placement_priority = productData.placement_priority
            }
            productsAll.push(product)
          })
          that.productsAll = productsAll
          that.productsFilter = that.productsAll
          const featuredOrderOptions = []
          for (let i = 1; i <= that.productsAll.length; i++) {
            featuredOrderOptions.push({ value: i, label: i })
          }
          that.featuredOrderOptions = featuredOrderOptions
          that.totalNum = that.productsAll.length
          that.handleCurrentChange(1)
        }
        that.flagLoading.getProductsAll = false
      }).catch(function (err) {
        console.error('getProductsAll', err)
        that.flagLoading.getProductsAll = false
      })
    },
    updateInstance: function () {
      this.flagLoading.save = true
      const url = `/api/v1/admin/mobile_instances/${this.instance._id}`
      const that = this
      const body = { type: 'products', products: this.productsAll }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: res.msg })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstance', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    generateIndex: function (index) {
      const { pageNum, pageSize } = this
      return index + 1 + pageSize * (pageNum - 1)
    },
    toggleProductActive: function (index) {
      const product = this.productsPage[index]
      const productActive = product.is_active ? 0 : 1
      this.productsPage[index].is_active = productActive
      if (!productActive) this.productsPage[index].is_featured = 0
      // const filterIndex = _.findIndex(this.productsFilter, { product_id: product.product_id })
      // if (filterIndex >= 0) this.productsFilter[filterIndex].is_active = productActive
      // const filterAll = _.findIndex(this.productsAll, { product_id: product.product_id })
      // if (filterAll >= 0) this.productsAll[filterAll].is_active = productActive
    },
    toggleProductFeatured: function (index) {
      // console.log('toggleProductFeatured', index)
      const product = this.productsPage[index]
      const productFeatured = product.is_featured ? 0 : 1
      this.productsPage[index].is_featured = productFeatured
      if (productFeatured) this.productsPage[index].is_active = 1
    },
    changeProductFeaturedOrder: function (index, val) {
      console.log('changeProductFeaturedOrder', index, val)
    },
    changeProductPlayerPosition: function (index, val) {
      console.log('changeProductPlayerPosition', index, val)
    },
    changeProductPlacementPriority: function (index, val) {
      console.log('changeProductPlacementPriority', index, val)
    },
    handleSizeChange: function (val) {
      this.pageSize = val
      this.generateProductsFilter()
    },
    handleCurrentChange: function (val) {
      this.pageNum = val
      this.generateProductsFilter()
    },
    generateProductsFilter: function () {
      const start = (this.pageNum - 1) * this.pageSize
      const end = this.pageNum * this.pageSize
      this.productsPage = this.productsFilter.slice(start, end)
    },
    handleFiltersChange: function () {
      let productsAll = [...this.productsAll]
      const productsFilter = []
      const sort = this.filters.sort
      switch (sort) {
        case 1:
          productsAll = _.sortBy(productsAll, function (el) { return parseInt(el.featured_order) })
          break
        case 2:
          productsAll = _.sortBy(productsAll, function (el) { return el.player_position })
          break
      }
      productsAll.map(item => {
        const searchText = this.filters.name
        if (searchText) {
          const productName = item.name
          const directMatch = productName.match(new RegExp(searchText, 'gi'))
          let indirectMatch = false
          const searchArray = searchText.split(' ')
          if (searchArray.length > 1) {
            indirectMatch = productName.match(new RegExp(searchArray[0], 'gi')) && productName.match(new RegExp(searchArray[1], 'gi'))
          }
          if (!directMatch && !indirectMatch) return
        }
        const isActive = this.filters.is_active
        if (isActive) {
          if (isActive === 1 && !item.is_active) return
          if (isActive === 2 && item.is_active) return
        }
        const isFeatured = this.filters.is_featured
        if (isFeatured) {
          if (isFeatured === 1 && !item.is_featured) return
          if (isFeatured === 2 && item.is_featured) return
        }
        productsFilter.push(item)
      })
      this.productsFilter = productsFilter
      this.totalNum = productsFilter.length
      this.pageNum = 1
      this.generateProductsFilter()
    }
  }
}
</script>

<style lang="scss" scoped>
.td-checkbox {
  height: 23px;
}
</style>
